module.exports = __webpack_public_path__ + "static/media/Akkurat.b930f04e.eot";